export type RouteMapPinKind =
  | "depot"
  | "assigned-stop"
  | "stop-pending"
  | "stop-delivered"
  | "stop-failed"
  | "driver";

const PIN_COLORS: Record<RouteMapPinKind, string> = {
  depot: "#2563eb",
  "assigned-stop": "#2563eb",
  "stop-pending": "#f59e0b",
  "stop-delivered": "#16a34a",
  "stop-failed": "#dc2626",
  driver: "#8b5cf6",
};

const PIN_BODY_PATH =
  "M17.5 2.746c-8.284 0-15 6.853-15 15.307 0 .963.098 1.902.265 2.816a15.413 15.413 0 002.262 5.684l.134.193 12.295 17.785 12.439-17.863.056-.08a15.422 15.422 0 002.343-6.112c.123-.791.206-1.597.206-2.423 0-8.454-6.716-15.307-15-15.307";

const PIN_SHADOW_PATH =
  "M17.488 2.748c-8.284 0-15 6.853-15 15.307 0 .963.098 1.902.265 2.816a15.413 15.413 0 002.262 5.684l.134.193 12.295 17.785 12.44-17.863.055-.08a15.422 15.422 0 002.343-6.112c.124-.791.206-1.597.206-2.423 0-8.454-6.716-15.307-15-15.307m0 1.071c7.68 0 13.929 6.386 13.929 14.236 0 .685-.064 1.423-.193 2.258-.325 2.075-1.059 3.99-2.164 5.667l-.055.078-11.557 16.595L6.032 26.14l-.12-.174a14.256 14.256 0 01-2.105-5.29 14.698 14.698 0 01-.247-2.62c0-7.851 6.249-14.237 13.928-14.237";

function getInnerIconSvg(kind: RouteMapPinKind, sequence?: number | string): string {
  if (kind === "depot") {
    return `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#ffffff" d="M4 10v10h5v-6h6v6h5V10L12 3 4 10zm2 2.16L12 6.84 18 12.16V18h-3v-6H9v6H6v-5.84z"/></svg>`;
  }

  if (kind === "driver") {
    return `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#ffffff" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>`;
  }

  if (sequence != null && String(sequence).trim() !== "") {
    return `<span style="display:flex;align-items:center;justify-content:center;width:16px;height:16px;color:#fff;font-size:10px;font-weight:700;line-height:1;">${String(
      sequence
    )}</span>`;
  }

  return `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#ffffff" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>`;
}

export function getRouteMapPinColor(kind: RouteMapPinKind): string {
  return PIN_COLORS[kind];
}

export function getStopPinKind(status?: string): RouteMapPinKind {
  if (status === "delivered") {
    return "stop-delivered";
  }
  if (status === "failed" || status === "not_delivered") {
    return "stop-failed";
  }
  return "stop-pending";
}

export function createRouteMapPinHtml(
  kind: RouteMapPinKind,
  options?: { sequence?: number | string }
): string {
  const fill = PIN_COLORS[kind];
  const innerIcon = getInnerIconSvg(kind, options?.sequence);

  return `
    <div style="position:relative;width:32px;height:44px;">
      <svg width="32" height="44" viewBox="0 0 35 45" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="${PIN_BODY_PATH}" fill="${fill}"></path>
        <path d="${PIN_SHADOW_PATH}" fill="#231f20" opacity="0.15"></path>
      </svg>
      <div style="position:absolute;left:50%;top:11px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;width:18px;height:18px;">
        ${innerIcon}
      </div>
    </div>
  `;
}

export const ROUTE_MAP_PIN_ICON_SIZE: [number, number] = [32, 44];
export const ROUTE_MAP_PIN_ICON_ANCHOR: [number, number] = [16, 44];
export const ROUTE_MAP_PIN_POPUP_ANCHOR: [number, number] = [0, -40];
